export default "__VITE_ASSET__4_R3CtjS__"